<div
  [attr.data-test]="testId()"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  (keydown.space)="onCardClick()"
  class="card-basic card-clickable"
  tabindex="0"
  role="button"
  [attr.aria-label]="(ariaLabel() | translate) || null"
  data-test="card-clickable"
>
  <div class="card-basic-body">
    <div class="row">
      @if (isLoading()) {
        <div class="col">
          <i class="fas fa-chart-mixed text-secondary fa-2x mb-3 placeholder placeholder-wave" aria-hidden="true"></i>
          <div class="h6"><span class="placeholder placeholder-wave w-100"></span></div>
        </div>
        <div class="col-auto align-self-center">
          <i class="fas fa-chevron-right text-secondary" aria-hidden="true"></i>
        </div>
      } @else {
        <div class="col">
          <i class="fas {{ cardIcon() }} text-secondary fa-2x mb-3" aria-hidden="true"></i>
          <div class="h6">{{ cardTitle() | translate }}</div>
        </div>
        <div class="col-auto align-self-center">
          <i class="fas fa-chevron-right text-secondary" aria-hidden="true"></i>
        </div>
      }
    </div>
  </div>
</div>
